import { useQuery } from "@tanstack/react-query";

import { UserLoggedIn } from "@nens/brostar/openapi-client";

import { getApi } from "@/api/api-configuration";

const uploadApi = getApi();

export const useUserLoggedInQuery = () => {
  return useQuery<UserLoggedIn>({
    queryKey: ["userLoggedInBRO"],
    queryFn: () => uploadApi.apiUsersLoggedIn(),
  });
};
